import React, { lazy } from 'react'
import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { Redirect } from 'react-router-dom'

const AcademyContainer = lazy(
  () => import('./AcademyContainer/AcademyContainer')
)

const AcademyCoursePage = lazy(() => import('./Course/AcademyCoursePage'))

const SingleResourcePage = lazy(
  () => import('./Resources/SingleResourcePage/SingleResourcePage')
)

const CoachingContainer = lazy(
  () => import('./Coaching/CoachingPage/CoachingPage')
)

const GroupCoachingContainer = lazy(
  () => import('./GroupCoaching/GroupCoaching')
)

const LearningTrackContainer = lazy(
  () => import('./LearningTracks/LearningTrack/LearningTrack')
)

const AllResourcesPage = lazy(
  () => import('./AllResourcesPage/AllResourcesPage')
)

const RecommendationsPage = lazy(
  () => import('./RecommendationsPage/RecommendationsPage')
)

const MyLibraryPage = lazy(() => import('./MyLibraryPage/MyLibraryPage'))
const MyHistoryPage = lazy(() => import('./MyHistoryPage/MyHistoryPage'))

const RedirectLegacySearch = lazy(
  () => import('./RedirectLegacySearch/RedirectLegacySearch')
)

const BrowseByTopicPage = lazy(
  () => import('./BrowseByTopicPage/BrowseByTopicPage')
)

const BrowseByResourceType = lazy(
  () => import('./BrowseByResourceType/BrowseByResourceType')
)

export default {
  path: '/academy',
  exact: false,
  Component: WithPermission(AcademyContainer, ['page:academy'], true),
  access: 'USER',
  routes: [
    {
      path: `/academy/resources`,
      exact: true,
      Component: () => <Redirect to='/academy/all-resources' />,
      access: 'USER',
    },
    {
      path: `/academy/all-resources`,
      exact: true,
      Component: AllResourcesPage,
      access: 'USER',
    },
    {
      path: `/academy/my-library`,
      exact: true,
      Component: MyLibraryPage,
      access: 'USER',
    },
    {
      path: `/academy/recommendations`,
      exact: true,
      Component: RecommendationsPage,
      access: 'USER',
    },
    {
      path: `/academy/resources/:topicName/:slug`,
      exact: true,
      Component: SingleResourcePage,
      access: 'USER',
    },
    {
      path: `/academy/resources/search`,
      exact: true,
      Component: RedirectLegacySearch,
      access: 'USER',
    },
    {
      path: '/academy/1-1-coaching',
      exact: true,
      Component: WithPermission(
        CoachingContainer,
        ['page:academy:1_1_coaching'],
        true
      ),
      access: 'USER',
    },
    {
      path: `/academy/saved-resources`,
      exact: true,
      Component: MyHistoryPage,
      access: 'USER',
    },
    {
      path: `/academy/trainings/:topicId/:courseId`,
      exact: true,
      Component: AcademyCoursePage,
      access: 'USER',
    },
    {
      path: [
        `/academy/learning-tracks`,
        `/academy/learning-tracks/:trackId`,
        `/academy/learning-tracks/:trackId/modules/:moduleId`,
        `/academy/learning-tracks/:trackId/modules/:moduleId/resources/:resourceId`,
      ],
      exact: true,
      Component: LearningTrackContainer,
      access: 'USER',
    },
    {
      path: `/academy/browse-by-topic`,
      exact: true,
      Component: BrowseByTopicPage,
      access: 'USER',
    },
    {
      path: `/academy/browse-by-resource-type`,
      exact: true,
      Component: BrowseByResourceType,
      access: 'USER',
    },
  ],
}
